<script lang="ts" context="module">
  export const thumbColorPaletteStore = writable(['#0A00FD', '#DBA03C']);
</script>

<script lang="ts">
  import {writable} from 'svelte/store';
  import ColorPalette from './ColorPalette.svelte';
  import {getInstance} from '../../../../services/animation';
  export let editorInstance: any;
  function colorChanged(ev: CustomEvent<any>, oldColor: string) {
    const newColor = ev.detail.color;
    editorInstance.history.addHistory('color change');
    getInstance().templateLoader.colorLoader.changeColor(oldColor, newColor);
  }
</script>

<div class="my-2 block" id="color_palette">
  <span class="black mb-2 block text-sm font-bold" id="sb-image-color-palette">Color Palette</span>
  <div class="flex h-12 w-full overflow-hidden rounded-lg border">
    {#each $thumbColorPaletteStore as color}
      <ColorPalette {editorInstance} on:color-change={ev => colorChanged(ev, color)} {color} />
    {/each}
  </div>
</div>
